import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ScreenSelector extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    let val = e.currentTarget.value;
    if (val) {
      this.props.onScreenSelected(val);
    }
  }

  render() {
    return this.props.screens.length ? (
      <div className="syos-key syos-key--optional">
        <ul className="syos-key__list">
          {this.props.screens.map((screen, idx) => {
            let zoneData = this.props.screenZoneData[screen.screen_no];
            let disabled = zoneData === undefined || zoneData.avail < 1;

            return (
              <li className="syos-key__list__item" key={screen.screen_no}>
                <input
                  type="radio"
                  className="syos-key__option-input"
                  onChange={this.onChange}
                  name="radio-screen"
                  id={`radio-screen-${idx}`}
                  value={screen.screen_no}
                  checked={this.props.selectedScreenId === screen.screen_no}
                  disabled={disabled}
                />
                <label
                  className="syos-key__option-label"
                  htmlFor={`radio-screen-${idx}`}
                >
                  {screen.screen_desc}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    ) : null;
  }
}

ScreenSelector.propTypes = {
  screens: PropTypes.arrayOf(PropTypes.object),
  screenZoneData: PropTypes.object,
  selectedScreenId: PropTypes.string,
  onScreenSelected: PropTypes.func
};

export default ScreenSelector;



// WEBPACK FOOTER //
// ./src/javascripts/components/ScreenSelector.js